import moment from 'moment'
import { message } from 'antd'
import { isArray, mapValues as _mapValues } from 'lodash'

export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val
}

export function getTimeDistance(type) {
  const now = new Date()
  const oneDay = 1000 * 60 * 60 * 24

  if (type === 'today') {
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    return [moment(now), moment(now.getTime() + (oneDay - 1000))]
  }

  if (type === 'week') {
    let day = now.getDay()
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)

    if (day === 0) {
      day = 6
    } else {
      day -= 1
    }

    const beginTime = now.getTime() - day * oneDay

    return [moment(beginTime), moment(beginTime + (7 * oneDay - 1000))]
  }

  if (type === 'month') {
    const year = now.getFullYear()
    const month = now.getMonth()
    const nextDate = moment(now).add(1, 'months')
    const nextYear = nextDate.year()
    const nextMonth = nextDate.month()

    return [
      moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      moment(
        moment(
          `${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`
        ).valueOf() - 1000
      )
    ]
  }

  if (type === 'year') {
    const year = now.getFullYear()

    return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)]
  }
}

export function getPlainNode(nodeList, parentPath = '') {
  const arr = []
  nodeList.forEach(node => {
    const item = node
    item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/')
    item.exact = true
    if (item.children && !item.component) {
      arr.push(...getPlainNode(item.children, item.path))
    } else {
      if (item.children && item.component) {
        item.exact = false
      }
      arr.push(item)
    }
  })
  return arr
}

export function digitUppercase(n) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let num = Math.abs(n)
  let s = ''
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * 10 ** index) % 10] + item).replace(
      /零./,
      ''
    )
  })
  s = s || '整'
  num = Math.floor(num)
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = ''
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p
      num = Math.floor(num / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }

  return s
    .replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整')
}

function getRelation(str1, str2) {
  if (str1 === str2) {
    message.warn('Two path are equal!') // eslint-disable-line
  }
  const arr1 = str1.split('/')
  const arr2 = str2.split('/')
  if (arr2.every((item, index) => item === arr1[index])) {
    return 1
  } else if (arr1.every((item, index) => item === arr2[index])) {
    return 2
  }
  return 3
}

function getRenderArr(routes) {
  let renderArr = []
  renderArr.push(routes[0])
  for (let i = 1; i < routes.length; i += 1) {
    let isAdd = false
    // 是否包含
    isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3)
    // 去重
    renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1)
    if (isAdd) {
      renderArr.push(routes[i])
    }
  }
  return renderArr
}

/**
 * Get router routing configuration
 * { path:{name,...param}}=>Array<{name,path ...param}>
 * @param {string} path
 * @param {routerData} routerData
 */
export function getRoutes(path, routerData) {
  let routes = Object.keys(routerData).filter(
    routePath => routePath.indexOf(path) === 0 && routePath !== path
  )
  // Replace path to '' eg. path='user' /user/name => name
  routes = routes.map(item => item.replace(path, ''))
  // Get the route to be rendered to remove the deep rendering
  const renderArr = getRenderArr(routes)
  // Conversion and stitching parameters
  const renderRoutes = renderArr.map(item => {
    const exact = !routes.some(
      route => route !== item && getRelation(route, item) === 1
    )
    return {
      exact,
      ...routerData[`${path}${item}`],
      key: `${path}${item}`,
      path: `${path}${item}`
    }
  })
  return renderRoutes
}

// 删除一个对象的多个属性
export function delKey(obj, ...args) {
  args.forEach(v => {
    delete obj[v]
  })
  return obj
}

/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g

export function isUrl(path) {
  return reg.test(path)
}

export function dataUrlToBlob(canvas) {
  let arr = canvas.toDataURL('image/jpeg').split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8Arr = new Uint8Array(n)
  while (n--) {
    u8Arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8Arr], { type: mime })
}

export const isPromise = obj =>
  obj && Object.prototype.toString.call(obj) === '[object Promise]'

export function getBrand(list, ids) {
  if (
    !list &&
    Object.prototype.toString.call(list, this) !== '[object Array]'
  ) {
    return null
  }
  if (!ids) {
    return null
  }
  if (Object.prototype.toString.call(ids, this) === '[object Array]') {
    let res = []
    ids.forEach(id => {
      let brandObj = list.find(item => {
        if (item.id === id) {
          return true
        }
      })
      brandObj && res.push(brandObj)
    })
    return res
  } else {
    return list.find(item => {
      if (item.id === ids) {
        return true
      }
    })
  }
}

/**
 * @callback Mapper
 * @param {object} node current node
 * @param {number} level
 * @param {object} parent parent node
 * @returns {'break' | 'continue' | null | undefined} return the enum value to break or continue the traverse
 *
 * @param {Mapper} action
 * @param {{childrenKeyName: string}} _options
 * @returns {function}
 */
export const traverseTreeCreator = (action, _options = {}) => list => {
  const childrenKeyName = _options.childrenKeyName || 'children'
  let stack = [...list]
  let level = 1
  let currentLevelLength = list.length
  let nextLevelLength = 0
  let parentQueue = [{ ref: 'ROOT', length: list.length }]

  while (stack.length) {
    const current = stack.shift()

    const parent = parentQueue[0]
    if (parent.length > 1) {
      parent.length -= 1
    } else {
      parentQueue.shift()
    }

    // action
    const result = action(current, level, parent?.ref)
    currentLevelLength -= 1
    if (result === 'break') {
      break
    } else if (result === 'continue') {
      continue
    }

    if (current[childrenKeyName]?.length) {
      stack = [...stack, ...current[childrenKeyName]]
      nextLevelLength += current[childrenKeyName].length
      parentQueue.push({
        ref: current,
        length: current[childrenKeyName].length
      })
    }

    if (currentLevelLength === 0) {
      ;[currentLevelLength, nextLevelLength] = [nextLevelLength, 0]
      level += 1
    }
  }
}

export function getDeepMap(data, options) {
  const { childrenKeyName = 'children', checkNode } = options
  const checkNodeFn = node => {
    if (typeof checkNode === 'function') {
      return checkNode(node)
    }
    return !node[childrenKeyName]
  }
  const getId = item => {
    const type = typeof options.id
    switch (type) {
      case 'string':
        return item[options.id]
      case 'function':
        return options.id(item)

      default:
        return ''
    }
  }

  let parentMap = {}
  let leafList = []

  let deepMap = {}

  traverseTreeCreator((item, _, parent) => {
    const id = getId(item)
    parentMap[id] = getId(parent)
    if (checkNodeFn(item)) {
      leafList.push(id)
    }
  }, options)(data)

  leafList.forEach(leaf => {
    let current = leaf
    let deep = 1
    while (current) {
      if (!deepMap[current] || deepMap[current] < deep) {
        deepMap[current] = deep
      } else break

      current = parentMap[current]
      deep += 1
    }
  })
  return deepMap
}

export const getTreeNodeId = node =>
  node.property || node.groupId || [node.groupCode, node.displayName].join('@')

export const setApplicationCode = applicationCode => (routes = []) =>
  routes.map(route => ({
    ...route,
    meta: {
      ...route.meta,
      applicationCode
    }
  }))

export const removeEmpty = obj => {
  if (isArray(obj)) return obj

  let newObj = {}
  Object.keys(obj).forEach(key => {
    if (obj[key] === Object(obj[key])) newObj[key] = removeEmpty(obj[key])
    else if (obj[key] !== undefined && obj[key] !== null) newObj[key] = obj[key]
  })
  return newObj
}
export const download = res => {
  if (!res) return
  let link = document.createElement('a')

  link.style.display = 'none'
  link.href = res

  document.body.appendChild(link)
  link.click()
}

/**
 * @param {moment} current
 * @returns {boolean}
 */
export const isBeforeToday = current => current < moment().startOf('day')

export const mapToOptions = obj =>
  Object.keys(obj).map(k => ({
    value: k,
    label: obj[k]
  }))

/**
 * 阻止冒泡和默认行为，例如 Radio 中 Select 弹出层的鬼畜
 */
export const resetClick = e => {
  e.preventDefault()
  e.stopPropagation()
}

/**
 * ({a: 1, b: 2}, {a: 'aa', b: 'bb'}) =>
 *    {aa: 1, bb: 2}
 * @param {object} object
 * @param {Record<string, string>} keyMap
 * @returns
 */
export const renameKeys = (object = {}, keyMap = {}) => {
  console.log(object)
  return Object.keys(object).reduce((result, key) => {
    const newKey = keyMap[key] || key
    return {
      ...result,
      [newKey]: object[key]
    }
  }, {})
}
renameKeys.fp = keyMap => i => renameKeys(i, keyMap)

export const mapValues = (object = {}, mapperConfig) => {
  if (typeof mapperConfig === 'function') {
    return _mapValues(object, mapperConfig)
  }
  return Object.keys(object).reduce((result, key) => {
    const oldValue = object[key]
    const newValue =
      typeof mapperConfig[key] === 'function'
        ? mapperConfig[key]?.(oldValue)
        : oldValue
    return {
      ...result,
      [key]: newValue
    }
  }, {})
}
mapValues.fp = config => o => mapValues(o, config)
